module.exports = __webpack_public_path__ + "static/media/fondo-2.206ba9f8.jpg";